export default __webpack_public_path__ + "static/chakra-ui-91d1d35e5e72728b9fef9c5b36c09268.svg";